import type { baiduModelConfig } from './types';
import { viduConfigs } from './configs/vidu';
import { pixverseConfigs } from './configs/pixverse';
import { klingConfigs } from './configs/kling';
import { hailuoConfigs } from './configs/hailuo';
import { googleConfigs } from './configs/google';
import { seedanceConfigs } from './configs/seedance';
import { happyhorseConfigs } from './configs/happyhorse';
import { minimaxConfigs } from './configs/minimax';

/**
 * 模型配置映射
 */
export const baiduModelConfigs: Record<string, baiduModelConfig> = {
    ...viduConfigs,
    ...pixverseConfigs,
    ...klingConfigs,
    ...hailuoConfigs,
    ...googleConfigs,
    ...seedanceConfigs,
    ...happyhorseConfigs,
    ...minimaxConfigs,
};
